import * as Filesaver from 'file-saver';
import { format } from 'date-fns';
import { formatInUTC } from '@mode/shared/util-js';

import { ChartDataTypes } from '@mode/shared/contract-common';

export namespace ChartExportHelper {
  export function saveAs(data: any[], name: string) {
    const timestamp = format(new Date(), 'yyyy-MM-dd');
    const fileName = `${name || 'Untitled Chart'} ${timestamp}.csv`;
    Filesaver.saveAs(new Blob(data, { type: 'text/plain;charset=utf-8' }), fileName);
  }

  export function makeCsv({ columns, content }: ChartDataTypes.Dataset) {
    // Bail if we can't print the header row
    if (columns.length === 0) {
      return [];
    }

    const length = content.length;
    // +1 to account for the header
    const csv = Array<string>(length + 1);

    // Set csv data @ provided row index. Will append
    // CRLF to each row except for the last one
    const put = (index: number, s: string) => {
      csv[index] = s + (index !== length ? '\r\n' : '');
    };

    // Headers
    put(0, columns.map((c) => quote(c.name)).join());

    // Rows: loops instead of map for SPEED!
    for (let i = 0; i < length; i++) {
      const item = content[i];
      put(
        i + 1,
        columns
          .map((c) => {
            return fmt(item[c.name], c.type.name);
          })
          .join()
      );
    }

    return csv;
  }
}

function quote(value: string) {
  return `"${value.replace(/"/g, '""')}"`;
}

function fmt(value: string | number | undefined | null, type: ChartDataTypes.Column.Type.Name) {
  if (value !== null && value !== undefined) {
    // Treat Infinity/NaN as empty values in CSV export
    if (typeof value === 'number' && !Number.isFinite(value)) {
      return '';
    }
    if (value === 'Infinity' || value === '-Infinity' || value === 'NaN') {
      return '';
    }
    switch (type) {
      case ChartDataTypes.Column.Type.Name.Date: {
        const date = new Date(value);
        if (!Number.isNaN(+date)) {
          return formatInUTC(date, 'yyyy-MM-dd HH:mm:ss');
        }
      }
      // Fall through for invalid dates, for the escaping
      case ChartDataTypes.Column.Type.Name.String: {
        return quote(value.toString());
      }
      default: {
        return value.toString();
      }
    }
  }
  return '';
}
